import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const UploadChanges = ({
    hasChanges,
    disableButtons,
    onRevert,
    onUpload,
}) => {

    const [translate] = useTranslation();
    return (
        <div className="card h-100">
            <div className="card-header border-bottom">
                <div className="h5 text-secondary">
                    {translate("OTM_UPLOAD_CHANGES")}
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-auto">
                        <Button
                            variant="primary"
                            onClick={onUpload}
                            disabled={!hasChanges || disableButtons}>
                            {translate("OTM_UPLOAD_CHANGES")}
                        </Button>
                    </div>
                    <div className="col-auto">
                        <Button
                            variant="danger"
                            onClick={onRevert}
                            disabled={!hasChanges || disableButtons}>
                            {translate("OTM_REVERT_CHANGES")}
                        </Button>
                    </div>
                </div>

                <div className="row mt-3">
                    <label>
                        {translate('OTM_UPLOAD_HELP_TEXT')}
                    </label>
                    <label>
                        {translate('OTM_REVERT_HELP_TEXT')}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default UploadChanges;